export default __webpack_public_path__ + "static/media/relationships.b1682ef4.svg";